<div class="tabbar-container">
  <app-tabbar-item routerLink="/home" icon="icon-home" [iconSize]="35"></app-tabbar-item>
  <app-tabbar-item routerLink="/contacts" icon="icon-contact-data-blue" [iconSize]="31"></app-tabbar-item>
  <app-tabbar-item routerLink="/turnarounds" icon="icon-day-of-operation-blue" [iconSize]="31"></app-tabbar-item>
  <app-tabbar-item routerLink="/chat" icon="icon-chats-and-messages-blue" [iconSize]="35" [indicatorText]="this.indicatorText"></app-tabbar-item>
  <app-tabbar-item routerLink="/completed" icon="icon-completed-flights-blue" [iconSize]="31"></app-tabbar-item>
</div>
